webpackJsonp([221374088121123],{

/***/ 126:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	module.exports = {"data":[]}

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Calendar.tsx
	 * -> Renders a calendar that uses the current calendar.json data as input.
	 */
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var CalendarEvent_1 = __webpack_require__(54);
	__webpack_require__(87);
	// Import the current calendar data
	var calendarData = __webpack_require__(23).data;
	calendarData = calendarData.sort(function (a, b) {
	    return new Date(a.start.dateTime).getTime() - new Date(b.start.dateTime).getTime();
	});
	/**
	 * Returns a formatted data string.
	 * @param date inputted Date object
	 */
	function formatAMPM(date) {
	    var hours = date.getHours();
	    var minutes = String(date.getMinutes());
	    var ampm = hours >= 12 ? "pm" : "am";
	    hours = hours % 12;
	    hours = hours ? hours : 12;
	    minutes = Number(minutes) < 10 ? '0' + minutes : minutes;
	    var strTime = hours + ":" + minutes + " " + ampm;
	    return strTime;
	}
	var Calendar = function Calendar() {
	    return React.createElement("div", { className: "calendar__container" }, React.createElement("div", { className: "calendar" }, React.createElement("div", { className: "calendar__header" }, React.createElement("div", { className: "calendar__count" }, calendarData.length, " upcoming event", calendarData.length > 1 ? 's' : null)), React.createElement("div", { className: "calendar__list" }, calendarData.map(function (event) {
	        var startDate = new Date(event.start.dateTime);
	        var month = startDate.toLocaleString('en-us', { month: "short" });
	        var day = startDate.toLocaleString('en-us', { day: "numeric" });
	        var time = formatAMPM(startDate);
	        // Default calendar type to social
	        var type = 'social';
	        // Super-basic, but good enough for now:
	        if (event.summary.toLowerCase().indexOf('workshop') !== -1) {
	            type = 'workshops';
	        } else if (event.summary.toLowerCase().indexOf('speaker') !== -1) {
	            type = 'speakers';
	        }
	        // Check if there's a link included
	        var urlRegex = /(https?:\/\/[^\s]+)/g;
	        var url = urlRegex.exec(event.description);
	        var parsedDescription = event.description ? event.description.replace(urlRegex, "") : "";
	        return React.createElement(CalendarEvent_1.default, { key: event.summary, month: month, day: day, time: time, type: type, url: url && url[0], title: event.summary, location: event.location, description: parsedDescription });
	    }))), React.createElement("div", { className: "calendar__meta" }, React.createElement("a", { href: "https://calendar.google.com/calendar?cid=c3RhbmZvcmQuZWR1X2RoNHZ1bW1la242M2RwOWd0aGxlMWw3cG0wQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20", rel: "noopener noreferrer", target: "_blank" }, React.createElement("span", null, "\uD83D\uDDD3"), " Follow our calendar ", React.createElement("small", null, "\u2197"))));
	};
	exports.default = Calendar;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * CalendarEvent.tsx
	 * -> Used by <Calendar> to display an event item.
	 */
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var Calendar = function Calendar(props) {
	    // If we get a link in our props, we render the component as a link to the event url (likely a FB event).
	    if (props.url) {
	        return React.createElement("a", { href: props.url, key: props.title, title: 'View event page ↗', className: 'calendar__event calendar__event-link calendar__event--' + props.type, rel: "noopener noreferrer", target: "_blank" }, React.createElement("div", { className: "calendar__event-dashes" }), React.createElement("div", { className: "calendar__event-date" }, React.createElement("div", { className: "calendar__event-month" }, props.month), React.createElement("div", { className: "calendar__event-day" }, props.day)), React.createElement("div", { className: "calendar__event-content" }, React.createElement("h1", { className: "calendar__event-title" }, props.title), React.createElement("h2", { className: "calendar__event-meta" }, props.time, "  \xB7  ", props.location), props.description.split("\n").map(function (text, index) {
	            return React.createElement("p", { key: index, className: "calendar__event-description" }, text);
	        })), React.createElement("div", { className: "calendar__event-icon" }));
	    } else {
	        return React.createElement("div", { key: props.title, className: 'calendar__event calendar__event--' + props.type }, React.createElement("div", { className: "calendar__event-dashes" }), React.createElement("div", { className: "calendar__event-date" }, React.createElement("div", { className: "calendar__event-month" }, props.month), React.createElement("div", { className: "calendar__event-day" }, props.day)), React.createElement("div", { className: "calendar__event-content" }, React.createElement("h1", { className: "calendar__event-title" }, props.title), React.createElement("h2", { className: "calendar__event-meta" }, props.time, "  \xB7  ", props.location), React.createElement("p", { className: "calendar__event-description" }, props.description)), React.createElement("div", { className: "calendar__event-icon" }));
	    }
	};
	exports.default = Calendar;

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.f835bcdb.svg";

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * index.tsx
	 * -> The actual homepage content.
	 */
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var gatsby_link_1 = __webpack_require__(13);
	var Calendar_1 = __webpack_require__(53);
	// Import json file of SAIG staff
	var people_1 = __webpack_require__(152);
	__webpack_require__(285);
	var Logo = __webpack_require__(51);
	
	var IndexPage = function (_React$Component) {
	    _inherits(IndexPage, _React$Component);
	
	    function IndexPage() {
	        _classCallCheck(this, IndexPage);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	        _this.state = {
	            personID: -1
	        };
	        return _this;
	    }
	
	    IndexPage.prototype.componentDidMount = function componentDidMount() {
	        this.setState({
	            // Choose a random person to show on the site
	            personID: Math.floor(Math.random() * people_1.default.length)
	        });
	    };
	
	    IndexPage.prototype.render = function render() {
	        var personID = this.state.personID;
	
	        var name = '';
	        var role = '';
	        var avatarClass = '';
	        if (personID > -1) {
	            // Pick a random person
	            var person = people_1.default[personID];
	            name = person.name;
	            role = person.role;
	            avatarClass = 'messages__avatar--' + person.id;
	        }
	        return React.createElement("div", { className: "page" }, React.createElement("div", { className: "messages__container" }, React.createElement("div", null, React.createElement("div", { className: "messages__avatar-title" }, name && role ? name + " \xB7 " + role : null), avatarClass ? React.createElement("div", { className: "messages__avatar " + avatarClass }) : null), React.createElement("div", { className: "messages__message messages__message-1" }, React.createElement("p", null, React.createElement("strong", null, "SAIG"), " is a student group which wants to be a part of shaping the future of artificial intelligence. We care about the tech ", React.createElement("span", { className: "italics" }, "and"), " the ethics involved.")), React.createElement("div", { className: "messages__message messages__message-combo messages__message-2" }, React.createElement(gatsby_link_1.default, { to: "join", className: "messages__message-survey" }, React.createElement("h3", null, "Join our mailing list"), React.createElement("p", null, "Follow our events and more!")), React.createElement("hr", null), React.createElement("a", { href: "https://www.facebook.com/groups/stanfordaigroup/", className: "messages__message-facebook", rel: "noopener noreferrer", target: "_blank" }, React.createElement("h3", null, "Join us on Facebook"), React.createElement("p", null, "Our group doesn't bite. \uD83D\uDE4B")))), React.createElement("div", { className: "content__container" }, React.createElement("div", { className: "bullets__container" }, React.createElement("div", { className: "bullets__bullet bullets__bullet-projects" }, React.createElement("div", { className: "bullets__bullet-icon" }), React.createElement("div", { className: "bullets__bullet-content" }, React.createElement("h3", null, "AI Projects"), React.createElement("p", null, "From chatbots to cutting-edge work in AI to machine learning\u2014we\u2019re interested in it all."))), React.createElement("div", { className: "bullets__bullet bullets__bullet-speakers" }, React.createElement("div", { className: "bullets__bullet-icon" }), React.createElement("div", { className: "bullets__bullet-content" }, React.createElement("h3", null, "World Class Speakers"), React.createElement("p", null, "We invite the world\u2019s experts to share their work."))), React.createElement("div", { className: "bullets__bullet bullets__bullet-tutorials" }, React.createElement("div", { className: "bullets__bullet-icon" }), React.createElement("div", { className: "bullets__bullet-content" }, React.createElement("h3", null, "Technical Tutorials"), React.createElement("p", null, "We host lectures and workshops for novices and experts alike."))))), React.createElement("div", { className: "content__divider" }), React.createElement(Calendar_1.default, null));
	    };
	
	    return IndexPage;
	}(React.Component);
	
	exports.default = IndexPage;

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	"use strict";
	/**
	 * people.ts
	 * -> Holds current board members of SAIG.
	 */
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var people = [{
	    id: 'junwon',
	    name: 'Junwon Park',
	    role: 'President of SAIG'
	}, {
	    id: 'tucker',
	    name: 'Tucker Haas',
	    role: 'Chief Financial Officer'
	}, {
	    id: 'roma',
	    name: 'Roma Dziembaj',
	    role: 'Vice President of Operations'
	}, {
	    id: 'john',
	    name: 'John Romano',
	    role: 'Vice President of Technical Education'
	}, {
	    id: 'swetha',
	    name: 'Swetha Revanur',
	    role: 'Vice President of Technical Education (Workshops)'
	}, {
	    id: 'yatharth',
	    name: 'Yatharth Agarwal',
	    role: 'Co-President and Vice President of Operations'
	}, {
	    id: 'shubhang',
	    name: 'Shubhang Desai',
	    role: 'Vice President of Technical Education (AI + Social Good)'
	}, {
	    id: 'andrewlesh',
	    name: 'Andrew Lesh',
	    role: 'Vice President of Ethical Education'
	}, {
	    id: 'sawyer',
	    name: 'Sawyer Birnbaum',
	    role: 'Vice President of Ethical Education'
	}, {
	    id: 'emily',
	    name: 'Emily Hu',
	    role: 'Vice President of Public Relations'
	}];
	exports.default = people;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-tsx-cc703e4b246ca86182b8.js